<template>
    <div class="Table">
        <div class="type">
            <span class="title">测试区域</span>
            <a-select ref="select" v-model:value="testZone" @change="testZoneChange" style="width: 363px;">
                <a-select-option v-for="item in selectData" :key="item.id" :value="item.id">
                    {{ item.name }}
                </a-select-option>
                <a-select-option :value="null">全部</a-select-option>
            </a-select>
        </div>
        <div class="table_content">
            <div class="table_title">实时测试车辆列表</div>

            <div class="table_main">
                <a-table :columns="columns" :loading="loading" :row-key="(record) => record.id" :data-source="data"
                    size="middle" :pagination="false" :scroll="{ y: '600px' }" :rowClassName="rowClassName"
                    :custom-row="customRow">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'carType'">
                            {{
                                getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + record.carType) ?
                                    getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + record.carType) :
                                    record.carType }}
                        </template>
                    </template>
                </a-table>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, defineProps, defineEmits, watch } from 'vue'

import { getSingleTypeValue } from "@/utils/matchDic.js";
import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const props = defineProps({
    selectData: {
        type: Array,
        default: () => {
            return []
        }
    },
    tableData: {
        type: Array,
        default: () => {
            return []
        }
    },
    showDrawer: {
        type: Boolean,
        default: () => false,
    },
    loading: {
        type: Boolean,
        default: false
    }
})

const columns = [
    {
        title: "车辆牌照",
        dataIndex: "testCarNum",
        key: "testCarNum",
    },
    {
        title: "车辆型号",
        dataIndex: "carType",
        key: "carType",
    },
    {
        title: "测试开始时间",
        dataIndex: "startTimeStr",
        key: "startTimeStr",
    },
];

const testZone = ref('')

const data = ref([])

const selectRowKey = ref(null)

watch(
    () => props.selectData,
    (val) => {
        console.log(val, 'selectData1111111111111111111111111');
        if (val.length > 0) {
            testZone.value = val[0].id
        } else {
            testZone.value = ''
        }
    }
)

watch(
    () => props.tableData,
    (val) => {
        console.log(val, 'tableData');
        if (val) {
            data.value = val
        }
    }
)

const emits = defineEmits(['zoneChangeEvent', 'tableclickRow'])

const testZoneChange = value => {
    emits('zoneChangeEvent', value)
}

const rowClassName = (record, index) => {
    console.log(record, index);
    console.log(selectRowKey.value);
    if (!props.showDrawer) {
        return ''
    } else {
        if (record.id == selectRowKey.value
        ) {
            return 'table_selected'
        }
    }

}


const customRow = (record) => {
    return {
        onClick: (e, b) => {
            selectRowKey.value = record.id
            emits('tableclickRow', { id: record.id, frameNum: record.carFrameNum, monitorDeviceId: record.monitorDeviceId })
        }
    }
}



</script>
<style lang="less" scoped>
.type {
    // width: 475px;
    height: 48px;
    background: #F6F8FA;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #BBD3EC;

    .title {
        display: inline-block;
        width: 112px;
        text-align: center;
        background: rgba(246, 248, 250);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1D2129;
    }
}

.table_content {
    width: 476px;
    background: #fff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(0, 0, 0, 0.25);

    .table_title {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #1D2129;
        position: relative;
        padding: 14px 0 17px 23px;

        &::before {
            content: '';
            display: inline-block;
            width: 3px;
            height: 12px;
            background: #1E8EF2;
            border-radius: 10px;
            position: absolute;
            top: 16px;
            left: 13px;
        }
    }

    .table_main {
        padding: 0 14px 17px 13px;
    }
}

/deep/.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 47px;
    border-radius: 2px 2px 2px 2px;
    background: #fff;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #636D7B;
}

/deep/.ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 48px;
}

/deep/.ant-select .ant-select-arrow {
    top: 55%;
}

/deep/.table_selected {
    background: rgba(234, 250, 255, 1);
}

/deep/.ant-table-wrapper .ant-table-tbody>tr.ant-table-row:hover>td {
    background: rgba(234, 250, 255, 1);
}
</style>
